import script from "./CreateNewApprovalConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateNewApprovalConfig.vue?vue&type=script&setup=true&lang=js"

import "./CreateNewApprovalConfig.vue?vue&type=style&index=0&id=5f7ce1f6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f7ce1f6"]])

export default __exports__